function obtenerPermisos(usuario, modulo) {
  if (usuario && usuario.rol_modulo_permisos) {
    return usuario.rol_modulo_permisos.find(
      (c) => c.codigo_rol == usuario.codigo_rol && c.nombre_modulo_permiso == modulo
    )
  }
  return {}
}

export const permiso = {
  obtenerPermisos
}
